import FilterIcon from "@assets/icons/filter"
import PatientDetailsTable from "./patientDetailsTable"
import PlusIcon from "@assets/icons/plus"
import { useEffect, useState } from "react"
import ArrowSquareLeftIcon from "@assets/icons/arrowSquareLeft"
import PageWrapper from "@components/Common/PageWrapper"
import styles from "./ManagePatientVision.module.css"
import { useNavigate } from "react-router"
import GoBack from "@components/Common/GoBack"
import FilterContainer from "@components/Common/Filters/FilterContainer"
import formatDateFromISOString from "src/utils/formatDate"
import { useSelector } from "react-redux"

const ManagePatientVision = () => {
  const [showFilters, setShowFilters] = useState(false)
  const [filterToBeExpanded, setFilterToBeExpanded] = useState(null)
  const [paginationState, setPaginationState] = useState({
    limit: 10,
    page: 1,
  })
  const navigate = useNavigate()
  const { patients } = useSelector((state) => state.patient)

  const filtersClickHandler = () => {
    setShowFilters(true)
  }
  const addPatientClickHandler = () => {
    navigate("/manage-patient-vision/add-new-patient")
  }
  const addRegisteredPatientClickHandler = () => {
    navigate("/manage-patient-vision/add-registered-patient")
  }
  useEffect(() => {
    const closeFilterOnEscape = (event) => {
      if (event.key === "Escape") {
        setShowFilters(false)
      }
    }
    window.addEventListener("keydown", closeFilterOnEscape)
    return () => {
      window.removeEventListener("keydown", closeFilterOnEscape)
    }
  }, [])

  // Define patient filters
  const patientFilters = [
    {
      filterName: "FIRST NAME",
      filterProperty: "firstName",
      filterPath: "local.firstName",
      dataSource: patients?.data || [],
    },
    {
      filterName: "LAST NAME",
      filterProperty: "lastName",
      filterPath: "local.lastName",
      dataSource: patients?.data || [],
    },
    {
      filterName: "EMAIL",
      filterProperty: "email",
      filterPath: "local.email",
      dataSource: patients?.data || [],
    },
    {
      filterName: "STATE",
      filterProperty: "province",
      filterPath: "local.province",
      dataSource: patients?.data || [],
    },
    {
      filterName: "CONTACT",
      filterProperty: "contact",
      filterPath: "local.contact",
      dataSource: patients?.data || [],
    },
    {
      filterName: "PINCODE",
      filterProperty: "pincode",
      filterPath: "local.pincode",
      dataSource: patients?.data || [],
    },
    {
      filterName: "CREATED AT",
      filterProperty: "createdAt",
      filterPath: "created_at",
      dataSource: patients?.data || [],
    },
    {
      filterName: "PLAN",
      filterProperty: "plan",
      filterPath: "plan",
      dataSource: patients?.data || [],
    },
  ]

  // Value transform functions
  const valueTransformFunctions = {
    createdAt: (value) => {
      const customDate = formatDateFromISOString(value)
      return customDate?.date
    },
  }

  return (
    <PageWrapper className={styles.managePatientVisionPage}>
      <>
        <div className={styles.headersAndControlsSection}>
          <div className={styles.header}>
            <GoBack className={styles.managePatientBackButton}>
              <ArrowSquareLeftIcon />
            </GoBack>
            <h1 className={styles.mainHeading}>Manage patient vision</h1>
            <p className={styles.description}>
              An overview of patient details and performance reports
            </p>
          </div>
          <div className={styles.patientControls}>
            <button
              className={styles.patientControlButton}
              onClick={filtersClickHandler}
            >
              <FilterIcon />
              FILTERS
            </button>
            <button
              className={
                styles.patientControlButton +
                " " +
                styles.addRegisteredPatientButton
              }
              onClick={addRegisteredPatientClickHandler}
            >
              <PlusIcon />
              ADD REGISTERED PATIENT
            </button>
            <button
              className={
                styles.patientControlButton + " " + styles.addNewPatientButton
              }
              onClick={addPatientClickHandler}
            >
              <PlusIcon stroke="#FFFFFF" />
              ADD NEW PATIENT
            </button>
          </div>
        </div>
        <PatientDetailsTable
          setShowFilters={setShowFilters}
          setFilterToBeExpanded={setFilterToBeExpanded}
          setPaginationState={setPaginationState}
          paginationState={paginationState}
        />

        {showFilters ? (
          <FilterContainer
            setShowFilters={setShowFilters}
            filterToBeExpanded={filterToBeExpanded}
            setFilterToBeExpanded={setFilterToBeExpanded}
            setPaginationState={setPaginationState}
            paginationState={paginationState}
            filters={patientFilters}
            title="Filter"
            valueTransformFunctions={valueTransformFunctions}
          />
        ) : null}
      </>
    </PageWrapper>
  )
}

export default ManagePatientVision
